// Time Off is unpriced (ADR 0014): the server sends zero rates for it, but showing $0.00
// would state a pay figure the payroll system will contradict, so those cells stay blank.
const PRICED_KEYS = ['payRate', 'payAmount', 'billRate', 'billAmount']

export const showsTypeSummaryValue = (summary, key) => {
  return !(summary.isTimeOff && PRICED_KEYS.includes(key))
}

export const toTypeSummaryExportRow = (summary, keys) => {
  const row = {}
  keys.forEach(key => { row[key] = showsTypeSummaryValue(summary, key) ? summary[key] : '' })
  return row
}
